import { colors } from '../../../config/constants';
import './style.css';

const UIAvatar = ({text, type, height, width, size}: any) => {

  let output = "";
  output = ((type === 'username' || type === 'name')  &&  text !== "") ? text?.substring(0,2).toUpperCase() : ""; 
  const colorObj = colors[Math.floor(Math.random() * colors
    .length)];


// const colorObj = colors[Math.floor(Math.random()*colors.length)];
  return (
    <div className="avatar" style={{...colorObj, border: '1px solid', height: height || "50px", width: width || "50px"}}>
        <div className="content" style={{fontSize: size || "14px"}}>{output}</div>
    </div>
  )
}

export { UIAvatar }